import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import * as Yup from "yup";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import {
  ALREADY_EXIST,
  SUCCESS_MESSAGE,
  ERROR_MESSAGE,
} from "../../../common/Constant";
import { toastError, toastSuccess } from "../../../common/Toast";

const ManageGiftCard = (props) => {
  const [loading, setLoading] = useState(false);
  const [selectInactive, setSelectInactive] = useState(false);
  const [IsAdded, setIsAdded] = useState(false);
  const [prevValue, setPrevValue] = useState(0);
  const [logMessages, setLogMessages] = useState([]);
  const [formValues, setFormValues] = useState({
    GiftcardNumber: "",
    Description: "",
    Value: "",
    CustomerName: "",
    Inactive: false,
  });

  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const loginUserName = localStorage.getItem("Name");

  let navigate = useNavigate();

  const paramObject = useParams();

  const validationSchema = Yup.object().shape({
    GiftcardNumber: Yup.string().required("GiftCard Number is required"),
    Value: Yup.number()
      .typeError("Giftcard Value must be a number")
      .required("GiftCard Value is required"),
  });

  const handleSelectInactive = () => {
    setSelectInactive(!selectInactive);
  };

  // const handleIsAdded = () => {
  //   setIsAdded(!IsAdded);
  // };

  const handleSubmit = (values) => {
    let logMessage = "";

    const currentValue = values.Value;

    if (paramObject.id > 0) {
      if (currentValue > prevValue) {
        logMessage = `${new Date().toLocaleString()} ${loginUserName} added $${currentValue - prevValue
          } to giftcard with a new value of $${currentValue}`;
      } else if (currentValue < prevValue) {
        logMessage = `${new Date().toLocaleString()} ${loginUserName} removed $${prevValue - currentValue
          } from giftcard with a new value of $${currentValue}`;
      }
    } else {
      logMessage = `${new Date().toLocaleString()} ${loginUserName} created giftcard with a value of $${currentValue}`;
    }
    let isAdded = currentValue > prevValue ? 0 : 1;

    let giftcardData = {
      id: paramObject.id || 0,
      giftcardnumber: values.GiftcardNumber,
      description: values.Description,
      value: values.Value,
      customerid: values.CustomerName,
      inactive: values.Inactive,
      loginuserid: loginUserId,
      logmassage: logMessage,
      isadded: isAdded,
    };

    const newLogMessages = [
      ...logMessages,
      // ...IsAdded,
      { text: logMessage, added: IsAdded },
    ];

    setLogMessages(newLogMessages);

    setLoading(true);
    axios
      .post(`${config.giftcardBaseUrl}/giftcards/upsert`, giftcardData, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          navigate("/giftcard");
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("GiftCard" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    //giftcard find by id
    if (paramObject.id > 0) {
      setLoading(true);
      axios
        .get(
          `${config.giftcardBaseUrl}/giftcards/selectbyid?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          const giftcardData = res.data.ResponseData.GiftCardDetails;
          const logMassage = res.data.ResponseData.LogMassage;

          setSelectInactive(giftcardData.Inactive === 1 ? true : false);
          setIsAdded(logMassage.IsAdded === 1 ? true : false);

          const data = {
            GiftcardNumber: giftcardData[0].GiftcardNumber,
            Description: giftcardData[0].Description,
            Value: giftcardData[0].Value,
            CustomerName: giftcardData[0].CustomerName,
            Inactive: giftcardData[0].Inactive === 1 ? true : false,
            LogMessage: logMassage[0].LogMessage,
            IsAdded: logMassage[0].IsAdded === 1 ? true : false,
          };

          const newData = { ...data };
          setPrevValue(giftcardData[0].Value);
          setLogMessages(logMassage, IsAdded);

          setFormValues(newData);

          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  }, []);

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div className="row mb-4">
            <div className="col">
              <h3 className="page-title">Gift Cards</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/giftcard">Gift Cards</Link>
                </li>
                <li className="breadcrumb-item active">New Gift Card</li>
              </ul>
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">Gift Card Information</h5>
            </div>
            <Formik
              initialValues={formValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ errors, touched, handleChange }) => (
                <Form>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            Gift Card Number
                            <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className={`form-control ${errors.GiftcardNumber ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="GiftcardNumber"
                              name="GiftcardNumber"
                            />
                            <div className="invalid-feedback">
                              {touched.GiftcardNumber && errors.GiftcardNumber
                                ? errors.GiftcardNumber
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            Description
                          </label>
                          <div className="col-lg-8">
                            <Field
                              as="textarea"
                              className={`form-control ${errors.Description ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="Description"
                              name="Description"
                            />
                            <div className="invalid-feedback">
                              {touched.Description && errors.Description
                                ? errors.Description
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            Value <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className={`form-control ${errors.Value ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              //onInput={handleIsAdded}
                              id="Value"
                              name="Value"
                            />
                            {touched.Value && errors.Value && (
                              <div className="invalid-feedback">
                                {errors.Value ===
                                  "GiftCard Value is required" ? (
                                  <span>{errors.Value}</span>
                                ) : (
                                  <span>Giftcard Value must be a number</span>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            Customer Name
                          </label>
                          <div className="col-lg-8">
                            <Field
                              type="text"
                              className={`form-control ${errors.CustomerName ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="CustomerName"
                              name="CustomerName"
                            />
                            <div className="invalid-feedback">
                              {touched.CustomerName && errors.CustomerName
                                ? errors.CustomerName
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            Inactive
                          </label>
                          <div className="col-lg-8">
                            <div className="input-group">
                              <Field
                                className="form-check-input"
                                style={{ width: "1.5em", height: "1.5em" }}
                                type="checkbox"
                                id="Inactive"
                                name="Inactive"
                                onChange={handleChange}
                                onInput={handleSelectInactive}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            Gift Card Log:
                          </label>

                          <div className="log-message-list">
                            {logMessages.map((message, index) => (
                              <div
                                key={index}
                                className={
                                  message.IsAdded === 0
                                    ? "alert alert-success m-2"
                                    : "alert alert-danger m-2"
                                }
                              >
                                {message.LogMessage}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div className="pull-right">
                        <Link
                          to="/giftcard"
                          className="btn btn-secondary mb-3 me-1 "
                        >
                          Cancel
                        </Link>
                        <button
                          type="submit"
                          className="btn btn-primary mb-3 me-3"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageGiftCard;
